import * as types from "../types/library";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveLibrary,
  unlockLibraryFile,
  deleteLibraryFile,
  prepareFileUpload,
  setNewFilePassword,
  removeFilePassword,
  deleteFileArray,
} from "../../networking/library/networking";

function* fetchLibraryDetails(action) {
  try {
    if (action.payload) {
      const files = yield call(retrieveLibrary, action.payload);
      if (files.error === null) {
        yield put({ type: types.SET_LIBRARY_CONTENT, content: files.payload });
      } else {
        throw new Error("Kunne ikke hente filer");
      }
    } else {
      throw new Error("Kunne ikke hente filer");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_LIBRARY_CONTENT, message: e });
  }
}

function* performFileUnlock(action) {
  try {
    if (action.details) {
      const file = yield call(unlockLibraryFile, action.details);
      if (file.error === null) {
        yield put({ type: types.GRANT_FILE_ACCESS, url: file.payload });
      } else {
        throw new Error("Kunne ikke låse opp fil");
      }
    } else {
      throw new Error("Kunne ikke låse opp fil.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FILE_ACCESS, message: e });
  }
}

function* performFileDeletion(action) {
  try {
    if (action.details) {
      var deletion = yield call(deleteLibraryFile, action.details);
      if (deletion.error === null) {
        yield put({ type: types.GRANT_FILE_DELETION });
        yield put({
          type: types.CHANGE_LIBRARY_MODALS,
          modal: { deleteModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette filen.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FILE_DELETION, message: e });
    yield put({
      type: types.CHANGE_LIBRARY_MODALS,
      modal: { deleteModal: false },
    });
  }
}

function* performFileUpload(action) {
  try {
    if (action.file) {
      var upload = yield call(prepareFileUpload, action.file);
      if (upload.error === null) {
        yield put({ type: types.GRANT_FILE_UPLOAD });
        yield put({
          type: types.CHANGE_LIBRARY_MODALS,
          modal: { uploadModal: false },
        });
      } else {
        throw new Error("Kunne ikke laste opp fil.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FILE_UPLOAD, message: e });
    yield put({
      type: types.CHANGE_LIBRARY_MODALS,
      modal: { uploadModal: false },
    });
  }
}

function* performSettingsSetFilePassword(action) {
  try {
    if (action.info) {
      var response = yield call(setNewFilePassword, action.info);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_PASSWORD_FILE });
        yield put({
          type: types.CHANGE_LIBRARY_MODALS,
          modal: { settingsModal: false },
        });
      } else {
        throw new Error("Kunne ikke passordbeskytte fil.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_PASSWORD_FILE, message: e });
    yield put({
      type: types.CHANGE_LIBRARY_MODALS,
      modal: { settingsModal: false },
    });
  }
}

function* performSettingsRemoveFilePassword(action) {
  try {
    if (action.info) {
      var response = yield call(removeFilePassword, action.info);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_PASSWORD_FILE });
        yield put({
          type: types.CHANGE_LIBRARY_MODALS,
          modal: { settingsModal: false },
        });
      } else {
        throw new Error("Kunne ikke fjerne passord.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_PASSWORD_FILE, message: e });
    yield put({
      type: types.CHANGE_LIBRARY_MODALS,
      modal: { settingsModal: false },
    });
  }
}

function* performRemoveFileArray(action) {
  try {
    if (action.details) {
      const response = yield call(deleteFileArray, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_FILE_ARRAY });
      } else {
        throw new Error("Kunne ikke slette filer.");
      }
    } else {
      throw new Error("Kunne ikke slette filer.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_FILE_ARRAY, message: e });
  }
}

function* librarySaga() {
  yield all([
    takeEvery(types.REQUEST_LIBRARY_CONTENT, fetchLibraryDetails),
    takeEvery(types.REQUEST_FILE_ACCESS, performFileUnlock),
    takeEvery(types.REQUEST_FILE_DELETION, performFileDeletion),
    takeEvery(types.REQUEST_FILE_UPLOAD, performFileUpload),
    takeEvery(types.REQUEST_ADD_PASSWORD_FILE, performSettingsSetFilePassword),
    takeEvery(
      types.REQUEST_REMOVE_PASSWORD_FILE,
      performSettingsRemoveFilePassword
    ),
    takeEvery(types.REQUEST_DELETE_FILE_ARRAY, performRemoveFileArray),
  ]);
}

export default librarySaga;
